<rt-heading variant="heading">{{ questionTitle() }}</rt-heading>
<span class="description">
  {{ 'app.evaluation_tab.form_details.files_count' | translate: { count: answersCount() } }}
  @if (commentsCount()) {
    ·
    {{ 'app.evaluation_tab.form_details.comments_count' | translate: { count: commentsCount() } }}
  }
</span>

@if (answersCount() === 0) {
  <rt-empty-state
    icon="thumbs-up-down"
    [title]="'app.evaluation_tab.form_details.no_files.title' | translate"
    [desc]="'app.evaluation_tab.form_details.no_files.description' | translate"
    margin-top-small
  />
} @else {
  <div class="attachments" margin-top-small>
    @for (item of items(); track item.id) {
      <rt-attachment-item type="card" [attachment]="item" />
    }
  </div>
}
